if($('html[lang="cs"]')){
    backToShop = 'Zpět do obchodu';
    buyButton = 'Koupit';
    rowCategory = 'Kategorie';
    askButton = 'Poptat';
    nameAndSurname = 'Uživatelské jméno nebo e-mail';
    password = 'Heslo';
    favoriteURL = 'oblibene';
    detailButton = 'Detail';
    returnabilityText = 'Návratnost';
}   

if($('html[lang="en"]')){
    backToShop = 'Back to the shop';
    buyButton = 'Buy';
    rowCategory = 'Category';
    askButton = 'Inquire';
    nameAndSurname = 'Username or e-mail';
    password = 'Password';
    favoriteURL = 'favorites';
    detailButton = 'Detail';
    returnabilityText = 'Returns';
}   